import React from "react";
import { Badge } from "react-bootstrap";
import ActionButtons from "components/ui/ActionButtons"; // Assuming you have this component

const TableRows = ({ 
  data, 
  columns, 
  onRowClick,
  onEdit,
  onDelete,
  onView,
  showActions = true,
  actionsColumn = true
}) => {
  const handleAction = (action, row) => {
    if (action === 'edit' && onEdit) onEdit(row);
    if (action === 'delete' && onDelete) onDelete(row);
    if (action === 'view' && onView) onView(row);
  };

  const renderCellContent = (col, row) => {
    if (col.render) {
      return col.render(row);
    }
    
    // Default rendering for common field types
    const value = row[col.key];
    
    // Render badges for status fields
    if (col.key === 'status' || col.key.includes('status')) {
      return (
        <Badge
          bg={value === 'online' || value === true ? 'success' : 'secondary'}
          className="rounded-pill px-3 py-1"
          style={{ fontSize: '0.85rem' }}
        >
          <i className={`fas fa-circle me-1 ${value === 'online' || value === true ? 'text-white' : 'text-light'}`} 
             style={{ fontSize: '0.5rem' }}></i>
          {value || 'offline'}
        </Badge>
      );
    }
    
    // Render count with badge
    if (col.key.includes('count') || col.key.includes('total')) {
      return (
        <div className="d-flex align-items-center">
          <Badge 
            bg="info" 
            className="rounded-pill me-2"
            style={{ minWidth: '40px' }}
          >
            {value || 0}
          </Badge>
          <span className="text-muted">
            Item{value !== 1 ? 's' : ''}
          </span>
        </div>
      );
    }
    
    // Render with icon for name/title fields
    if (col.key === 'name' || col.key === 'title') {
      return (
        <div className="d-flex align-items-center">
          <div className="category-icon bg-primary bg-opacity-10 text-primary rounded-circle p-2 me-3">
            <i className="fas fa-tag"></i>
          </div>
          <div>
            <h6 className="mb-0 fw-semibold">{value}</h6>
            {row._id && (
              <small className="text-muted">ID: {row._id?.substring(0, 8)}...</small>
            )}
          </div>
        </div>
      );
    }
    
    return value;
  };

  return (
    <>
      {data?.map((row, i) => (
        <tr 
          key={row._id || i} 
          className="align-middle machine-list-item-row"
          onClick={() => onRowClick && onRowClick(row)}
          style={{ cursor: onRowClick ? 'pointer' : 'default' }}
        >
          {columns.map((col, idx) => (
            <td 
              key={idx} 
              className={`${idx === 0 ? 'ps-4' : ''} ${idx === columns.length - 1 ? 'pe-4 text-end' : ''}`}
              style={{ padding: '1rem', verticalAlign: 'middle' }}
            >
              {renderCellContent(col, row)}
            </td>
          ))}
          
          {/* Actions Column */}
          {showActions && actionsColumn && (
            <td className="text-end pe-4 listing-actions-cell">
              <ActionButtons
                onEdit={() => handleAction('edit', row)}
                onDelete={() => handleAction('delete', row)}
                onView={() => handleAction('view', row)}
                showView={true}
                size="sm"
                variant="outline"
              />
            </td>
          )}
        </tr>
      ))}
    </>
  );
};

export default TableRows;
